/**
 * 논서술형(essay) 챕터 풀이 도메인 fetcher 모음. 타입 + 훅 + POST 액션을 재export.
 * user-api `/app/essay-learning/**` 전체를 이 폴더 하나로 다룬다.
 */
export * from "./types";
export {
  useGetEssayChapter,
  postEssayChapterStart,
  postEssayChapterSubmit,
} from "./useGetEssayChapter";
export {
  postEssayScenarioStart,
  postEssayScenarioTimeout,
} from "./useScenarioActions";
export {
  postEssayBlockSave,
  postEssayQuestionLock,
} from "./useBlockAnswer";
export { postEssayPinAttempt } from "./usePinAttempt";
export {
  postEssayChapterSuspend,
  postEssayChapterResume,
  postEssayChapterHeartbeat,
  sendEssaySuspendKeepalive,
  sendEssayAuditKeepalive,
} from "./useChapterSuspend";
// 레거시 호환 stub (home 의존 보존)
export { useGetEssayPreview } from "./useGetEssayPreview";
